import types from 'redux/types';

const getDomain = () => {
  return {
    type: types.REQUEST_GET_DOMAIN,
  };
};

const addDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_ADD_DOMAIN,
  };
};

const deleteDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_DOMAIN,
  };
};

const searchDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_SEARCH_DOMAIN,
  };
};

const buyDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_BUY_DOMAIN,
  };
};

const updateDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_UPDATE_DOMAIN,
  };
};

const updateAllDomain = () => {
  return {
    type: types.REQUEST_UPDATE_ALL_DOMAIN,
  };
};

const setupDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_SETUP_DOMAIN,
  };
};

const clearDataSearch = () => {
  return {
    type: types.REQUEST_CLEAR_DATA_SEARCH_DOMAIN,
  };
};

const getAllDomainGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_ALL_DOMAIN_GROUP,
  };
};

const loadMoreAllDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_LOAD_MORE_ALL_DOMAIN,
  };
};

const deleteDomainGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_DELETE_DOMAIN_GROUP,
  };
};

const migrateDomainGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_MIGRATE_DOMAIN_GROUP,
  };
};

const createDomainGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_CREATE_DOMAIN_GROUP,
  };
};

const loadDomainsInGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_LOAD_DOMAINS_IN_GROUP,
  };
};

const resetDomainInGroup = (data) => {
  return {
    ...data,
    type: types.REQUEST_RESET_DOMAIN_IN_GROUP,
  };
};

const saveDomainGroupSetting = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_DOMAIN_GROUP_SETTING,
  };
};

const cancelSearchDomain = () => {
  return {
    type: types.REQUEST_SEARCH_DOMAIN_CANCEL,
  };
};

const getCampaignInDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_CAMPAIGN_IN_DOMAIN,
  };
};

const getResponderInDomain = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_RESPONDER_IN_DOMAIN,
  };
};

const releaseDomainNow = (data) => {
  return {
    ...data,
    type: types.REQUEST_RELEASE_DOMAIN_NOW,
  };
};

const releaseDomainSelected = (data) => {
  return {
    ...data,
    type: types.REQUEST_RELEASE_DOMAIN_SELECTED,
  };
};

const getBuyingProcess = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_BUYING_PROCESS,
  };
};

export default {
  getBuyingProcess,
  releaseDomainSelected,
  releaseDomainNow,
  getResponderInDomain,
  getCampaignInDomain,
  loadMoreAllDomain,
  cancelSearchDomain,
  loadDomainsInGroup,
  createDomainGroup,
  migrateDomainGroup,
  deleteDomainGroup,
  getAllDomainGroup,
  resetDomainInGroup,
  clearDataSearch,
  setupDomain,
  updateDomain,
  updateAllDomain,
  buyDomain,
  searchDomain,
  deleteDomain,
  getDomain,
  addDomain,
  saveDomainGroupSetting,
};
